// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.quote-block[data-v-f6249b4e] {\n  border-left: 8px solid var(--v-panel-darken1);\n  padding-left: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
